import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleApiError} from "../../helpers/handleApiError";
import Payment from "../../api/repositories/payment";
import { updateUserDeliveryInfo } from './dashboard';

const initialState = {
  cardPaymentsLink: [],
  invoicePaymentsLink: [],
  deliveryAddresses: [],
  loading: false,
  error: null
};

export const buyStarterPackCard = createAsyncThunk(
    "pay/buyStarterPackCard",
    async (payload) => {
      try{
        const response = await Payment.buy_starter_pack_card(payload)
        return response.data;
      } catch (error){
        handleApiError(error)
      }
    }
)
export const buyGrowthPackCard = createAsyncThunk(
    "pay/buyGrowthPackCard",
    async (payload) => {
      try{
        const response = await Payment.buy_growth_pack_card(payload)
        return response.data;
      } catch (error){
        handleApiError(error)
      }
    }
)
export const buyEnterprisePackCard = createAsyncThunk(
    "pay/buyEnterprisePackCard",
    async (payload) => {
      try{
        const response = await Payment.buy_enterprise_pack_card(payload)
        return response.data;
      } catch (error){
        handleApiError(error)
      }
    }
)

export const buyStarterPackInvoice = createAsyncThunk(
    "pay/buyStarterPackInvoice",
    async (payload) => {
      try{
        const response = await Payment.buy_starter_pack_invoice(payload)
        return response.data;
      } catch (error){
        handleApiError(error)
      }
    }
)
export const buyGrowthPackInvoice = createAsyncThunk(
    "pay/buyGrowthPackInvoice",
    async (payload) => {
      try{
        const response = await Payment.buy_growth_pack_invoice(payload)
        return response.data;
      } catch (error){
        handleApiError(error)
      }
    }
)
export const buyEnterprisePackInvoice = createAsyncThunk(
    "pay/buyEnterprisePackInvoice",
    async (payload) => {
      try{
        const response = await Payment.buy_enterprise_pack_invoice(payload)
        return response.data;
      } catch (error){
        handleApiError(error)
      }
    }
)

export const processPrintOrderCard = createAsyncThunk(
  'pay/processPrintOrderCard',
  async (payload, { rejectWithValue }) => {
    try {
      const { order_id, amount, orderType } = payload;
      const response = await Payment.processPrintOrderCard({
        order_id,
        amount,
        orderType
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: 'Payment processing failed' });
    }
  }
);

export const processPrintOrderInvoice = createAsyncThunk(
  'pay/processPrintOrderInvoice',
  async (payload, { rejectWithValue }) => {
    try {
      const { order_id, amount, orderType } = payload;
      const response = await Payment.processPrintOrderInvoice({
        order_id,
        amount,
        orderType
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: 'Payment processing failed' });
    }
  }
);

export const getDeliveryAddresses = createAsyncThunk(
  'payment/getDeliveryAddresses',
  async (_, { dispatch }) => {
    try {
      const response = await Payment.getDeliveryAddresses();
      const addresses = response?.data?.Addresses || [];
      
      if (addresses.length > 0) {
        const address = addresses[0];
        console.log("Delivery address found:", address);
        
        if (address) {
          const formattedAddress = {
            full_name: address.full_name || '',
            phone_number: address.phone_number || '',
            email_address: address.email_address || '',
            country: address.country || '',
            city: address.city || '',
            street_address: address.street_address || '',
            postal_code: address.postal_code || '',
            _id: address._id || ''
          };
          
          dispatch(updateUserDeliveryInfo(formattedAddress));
        }
      } else {
        console.log("No delivery addresses found");
      }
      
      return { Addresses: addresses };
    } catch (error) {
      console.error("Error in getDeliveryAddresses:", error);
      return { Addresses: [] };
    }
  }
);

export const updateDeliveryAddress = createAsyncThunk(
  'payment/updateDeliveryAddress',
  async ({ addressId, addressData }, { rejectWithValue }) => {
    try {
      const response = await Payment.updateDeliveryAddress(addressId, addressData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(buyStarterPackCard.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(buyStarterPackCard.fulfilled, (state, {payload}) => {
          state.isLoading = false;
          state.cardPaymentsLink[0] = payload.Event
        })
    builder
        .addCase(buyGrowthPackCard.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(buyGrowthPackCard.fulfilled, (state, {payload}) => {
          state.isLoading = false;
          state.cardPaymentsLink[1] = payload.Event
        })
    builder
        .addCase(buyEnterprisePackCard.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(buyEnterprisePackCard.fulfilled, (state, {payload}) => {
          state.isLoading = false;
          state.cardPaymentsLink[2] = payload.Event
        })
    builder
        .addCase(buyStarterPackInvoice.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(buyStarterPackInvoice.fulfilled, (state, {payload}) => {
          state.isLoading = false;
          state.invoicePaymentsLink[0] = payload.Event
        })
    builder
        .addCase(buyGrowthPackInvoice.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(buyGrowthPackInvoice.fulfilled, (state, {payload}) => {
          state.isLoading = false;
          state.invoicePaymentsLink[1] = payload.Event
        })
    builder
        .addCase(buyEnterprisePackInvoice.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(buyEnterprisePackInvoice.fulfilled, (state, {payload}) => {
          state.isLoading = false;
          state.invoicePaymentsLink[2] = payload.Event
        })
    builder
        .addCase(getDeliveryAddresses.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getDeliveryAddresses.fulfilled, (state, action) => {
          state.loading = false;
          state.deliveryAddresses = action.payload?.Addresses || [];
        })
        .addCase(getDeliveryAddresses.rejected, (state) => {
          state.loading = false;
          state.deliveryAddresses = [];
        })
        .addCase(updateDeliveryAddress.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateDeliveryAddress.fulfilled, (state, action) => {
          state.loading = false;
          // Could update the address in the local state if needed
        })
        .addCase(updateDeliveryAddress.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
  },
});

export default paymentSlice.reducer;
